<template>
  <div id="VisitorRealNameSuccess">
    <div class="header">
      <img
        src="@/assets/img/login/logo.png"
        alt="智生活 Logo"
      >
    </div>
    <div class="main">
      <img
        src="@/assets/img/visitor/success@3x.png"
        alt=""
      >
      <div class="title">
        完成登記
      </div>
      <div class="content">
        請向管理櫃檯確認
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#VisitorRealNameSuccess {
  .header {
    height: 64px;
    background-color: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 39px;
    }
  }
  .main {
    box-sizing: border-box;
    height: calc(100vh - 64px);
    padding: 36px 16px 32px 16px;
    background-color: #fff;
    color: #333333;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      height: 120px;
      width: 120px;
      margin-bottom: 25px;
    }
    .title {
      font-size: 25px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .content {
      font-size: 15px;
      color: #555555;
    }
  }
}
</style>
